// extracted by mini-css-extract-plugin
export default {"items":"GalleryPage_items__Qj2-t","empty":"GalleryPage_empty__5bq8j","subtitle":"GalleryPage_subtitle__c4m0S"};